module.exports = __webpack_public_path__ + "static/media/financepic3@3x.c44f6014.png";